"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useProps2 = _interopRequireDefault(require("../hooks/useProps"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ContentContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n"])), function (props) {
  return props.bgColor;
});

var TabsContent = function TabsContent(_ref) {
  var tabId = _ref.tabId;

  var _useProps = (0, _useProps2.default)(),
      children = _useProps.children,
      _useProps$widgetCusto = _useProps.widgetCustomization.bgColor,
      bgColor = _useProps$widgetCusto === void 0 ? '#f4f4f4' : _useProps$widgetCusto;

  return /*#__PURE__*/_react.default.createElement(ContentContainer, {
    bgColor: bgColor
  }, Array.isArray(children) ? children.filter(function (el) {
    return el.props.id === tabId;
  }) : children);
};

TabsContent.propTypes = {
  tabId: _propTypes.default.string.isRequired
};
var _default = TabsContent;
exports.default = _default;